import {isNonNullish} from 'remeda'
import {notNull} from 'shared/type'
import {z} from 'zod'

export const zMention = z.object({
  type: z.enum(['question', 'profile']),
  path: z.string(),
  title: z.string()
})
export type MentionProps = z.infer<typeof zMention>

export namespace Mention {
  export const markdownPattern = `\\[([^\\]]+)\\]\\(swift://([^\\s)]+)\\)`
  export const markdownRegex = new RegExp(markdownPattern)

  export const fromText = (text: string) =>
    Array.from(text.matchAll(new RegExp(markdownPattern, 'g')))
      .map(fromRegexMatch)
      .filter(notNull)
  export const fromRegexMatch = (match: RegExpMatchArray) => {
    const [, title, fullPath] = match
    const [type, ...path] = fullPath?.split('/') ?? []
    const m = zMention.safeParse({title, type, path: path.join('/')})
    return m.success ? m.data : undefined
  }

  export const fromUrl = (url: string) => {
    const match = url.match(/swift:\/\/([^\s)]+)/)
    if (!match) return undefined
    const [, fullPath] = match
    const [type, ...path] = fullPath?.split('/') ?? []
    const m = zMention.pick({type: true, path: true}).safeParse({type, path: path.join('/')})
    return m.success ? m.data : undefined
  }

  export const markdown = (m: MentionProps) => `[${m.title}](swift://${m.type}/${m.path})`

  export const questionMarkdown = (q: {question_id: string; subquestion_id?: string; title: string}) =>
    markdown({type: 'question', path: [q.question_id, q.subquestion_id].filter(isNonNullish).join('/'), title: q.title})

  export const profileMarkdown = (p: {id: string; name: string}) =>
    markdown({type: 'profile', path: p.id, title: p.name})
}
